import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  Button,
  DocumentsList,
  LogoLoader,
  Modal,
  NewTable,
  StatusTags,
  TableAdv,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import { dateFormator } from "../../../../../utils/dateFormator";
import { lcaData } from "../../../../../assets/data/candidatesData";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllImmigrationsStart,
  getCurrentEmployeeImmigration,
} from "../../../../../redux/slices/immigration/immigrationSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";

const Lca = ({ handleEdit }) => {
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      // dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);

  const {
    immigrations: immigrationsTableData,
    currentEmployeeImmigration,
    loading,
  } = useSelector((state) => state.immigration);
  const {
    employeeProfileUiid,
    currentEmployee: { employeeDetails, loadedTabs },
    error,
    employees,
  } = useSelector((state) => state.employee);
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const isLoading = loading;
  const lcaTableData = currentEmployeeImmigration?.lca || [];
  const handleclick = () => {
    setDocumentModal(!documentModal);
  };

  const totalCount = value?.celca?.data || 0;
  const tableData =
    Array.isArray(immigrationsTableData?.data?.lca) &&
    immigrationsTableData.data.lca.length > 0
      ? immigrationsTableData.data.lca
      : [];
  const handelDocumetsModal = (documents) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(documents);
  };
  const columns = [
    {
      key: "number",
      label: "LCA Number",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">{row.number}</span>
        </div>
      ),
      sortable: false,
    },

    {
      key: "location",
      label: "Location",
      sortable: false,
      render: (row) => {
        const filteredData = row.placeOfEmployment
          .map(({ address }) => ({
            address: { city: address.city, state: address.state },
          }))
          .filter(({ address }) => address.city && address.state)
          .reduce((acc, current) => {
            const identifier = `${current.address.city}, ${current.address.state}`;
            if (
              !acc.some(
                ({ address }) =>
                  `${address.city}, ${address.state}` === identifier,
              )
            )
              acc.push(current);
            return acc;
          }, []);
        return (
          <div>
            {filteredData.map((data, index) => {
              return (
                <div key={index}>
                  {data?.address?.city} {data?.address?.state}{" "}
                </div>
              );
            })}
          </div>
        );
      },
    },
    {
      key: "prevailingWage",
      label: "Prevailing Wage",
      sortable: false,
      render: (row) => {
        return <div>{row?.salaryInfo?.wageRate}</div>;
      },
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
      sortable: false,
    },
    {
      key: "endDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
      sortable: false,
    },

    {
      key: "status",
      label: "LCA Status",
      render: (row) => (
        <StatusTags
          tag={
            row.status === 1
              ? "Certified"
              : row.status === 2
                ? "Withdrawn"
                : row.status === 3
                  ? "Denied"
                  : "In Process"
          }
        />
      ),
      sortable: false,
    },
    {
      key: "statusData",
      label: "Status",
      render: (row) => {
        const endDate = new Date(row.endDate);
        const today = new Date();

        // Compare the endDate with today's date (set time to 00:00:00 for proper comparison)
        const isExpired = endDate < today;

        return <div>{isExpired ? "Inactive" : "Active"}</div>;
      },
    },
    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        const combineData = [
          ...(row?.attachments?.certified || []),
          ...(row?.attachments?.paper || []),
          // ...(row?.lcaDocs || []),
        ];
        const combinedAttachments = (row?.advertisements || []).flatMap(
          (ad) => ad.attachment,
        );
        const applyfilePath = combinedAttachments.map((data) => ({
          filePath: data,
        }));
        const applyTransFormFiles = transformFiles(combineData);
        const combineAllData = [...applyTransFormFiles, ...applyfilePath];
        return (
          // <div
          //   className="flex items-center gap-1 flex-row cursor-pointer"
          //   onClick={() => handleclick()}
          // >
          //   <span className="text-linkblue">{row.documents} Docs </span>
          //   <div>
          //     <Button
          //       type="icon"
          //       icon="docs"
          //       size="xs"
          //       variant="text"
          //       color="black"
          //     />
          //   </div>
          // </div>
          <div
            className={`flex items-center gap-1 flex-row ${
              combineAllData.length > 0 && "cursor-pointer"
            }`}
            onClick={
              combineAllData.length > 0
                ? () => handelDocumetsModal(combineAllData)
                : () => {}
            }
          >
            <span className={`${combineAllData.length > 0 && "text-linkblue"}`}>
              {combineAllData.length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
      sortable: false,
    },
    // {
    //   key: "paf",
    //   label: "PAF",
    //   sortable: false,
    // },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          size="xs"
          color="info"
          onClick={() => handleEdit(row)}
        />
      ),
    },
  ];
  console.log("employeeDetails", employeeDetails);
  useEffect(() => {
    if (
      employeeProfileUiid
      // employeeDetails?.immigrations?.length > 0
    ) {
      const filter = {
        employeeId: { type: "NONE", value: employeeProfileUiid },
      };
      dispatch(
        totalCountStart({
          collection: "lcas",
          coll: "LCA",
          tname: "celca",
          filters: filter,
        }),
      );
      dispatch(
        getCurrentEmployeeImmigration({
          coll: "LCA",
          rsn: "lca",
          limit,
          filter,
          page,
          ref: "Employee Entity Paper Cert",
          incl: ["uiid firstName", "businessName"],
        }),
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch, page, limit]);
  const mappedRows = mapTableRows(lcaTableData, columns);
  return (
    <div className="w-full h-full">
      <TableAdv
        tableId={`employee_workauthorization_lca`}
        serverPagination={true}
        totalCount={totalCount}
        rows={mappedRows}
        columns={columns}
        // toolbarRight={[{ hideToolbar: true }]}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Lca;
